export default __webpack_public_path__ + "static/media/rightImg.7115a0ea.png";